//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "Date",
  props: ["value"],
  data: () => ({
    storedDate: null,
    comparisonOperator: null,
    comparisonList: [
      //{label: "escolha comparador", value: null},
      { label: "Igual", value: "=" },
      { label: "Diferente", value: "!=" },
      { label: "Menor", value: "<" },
      { label: "Menor ou Igual", value: "<=" },
      { label: "Maior", value: ">" },
      { label: "Maior ou Igual", value: ">=" },
      { label: "Valor Nulo", value: "= null" },
      { label: "Valor não Nulo", value: "!= null" }
    ]
  }),
  mounted: function () {
    if (this.value) {
      this.storedDate = this.value.value;
      this.comparisonOperator = this.comparisonList.find(e => e.value === this.value.comparisonOperator);
    }
  },
  computed: {
    date: {
      get() {
        return this.storedDate;
      },
      set(value) {
        this.$emit("input", {
          ...this.value,
          value: value,
          comparisonOperator: this.comparisonOperator.value
        });
        this.storedDate = value;
      },
    },
    //Disables the value input if no operator is chosen or the null operators are selected
    hasSelectedOperator: {
      get() {
        return this.comparisonOperator == null || this.comparisonOperator.value == "= null" || this.comparisonOperator.value == "!= null"
      }
    }
  },
  methods: {
    updateValues: function () {
      if (this.comparisonOperator.value == "= null" || this.comparisonOperator.value == "!= null") {
        this.$emit("input", {
          ...this.value,
          value: "",
          comparisonOperator: this.comparisonOperator.value
        });
        this.storedDate = null;
      } else {
        this.$emit("input", {
          ...this.value,
          value: this.storedDate,
          comparisonOperator: this.comparisonOperator.value
        });
      }
    }
  },
  watch: {
    value: function () {
      if (this.value.value != this.storedDate) {
        this.storedDate = this.value.value;
      }
      this.comparisonOperator = this.comparisonList.find(e => e.value === this.value.comparisonOperator);
    }
  }
};
